import React from "react";
import injectSheet from "react-jss";
import { NumberField, TextButton } from "../../";

class BudgetInput extends React.Component {
	constructor(props) {
		super(props);

		const { value } = props;

		this.state = {
			value,
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.state.value) {
			this.setState({
				value: nextProps.value,
			});
		}
	}

	handleChange(values) {
		const value = !Number.isNaN(values.floatValue) ? values.floatValue : "";
		this.setState({
			value,
		});
	}

	handleSubmit() {
		const { increment, max, min, setBudget } = this.props;

		const value = Math.min(
			Number.parseInt(Math.max(this.state.value, min) / increment, 10) *
				increment,
			max,
		);
		setBudget(value);
		this.setState({
			value,
		});
	}

	render() {
		const { classes, currency, increment, min, max, placeholder } = this.props;

		const { value } = this.state;

		return (
			<div className={`${classes.inputContainer}`}>
				<NumberField
					displayType="input"
					handleChange={this.handleChange}
					handleSubmit={this.handleSubmit}
					min={Number.parseInt((min / increment) * increment, 10)}
					max={max}
					placeholder={placeholder}
					suffix={` ${currency}`}
					value={value}
				/>
				<TextButton
					handleClick={this.handleSubmit}
					index={0}
					text="einstellen"
					primary
				/>
			</div>
		);
	}
}

const styles = (theme) => ({
	inputContainer: {
		width: "100%",
		padding: `${theme.sizes.gutter}px ${theme.sizes.gutter / 2}px`,
		display: "flex",
		justifyContent: "center",
		"& .button": {
			fontSize: "60%",
			[theme.media.medium]: {
				fontSize: "100%",
			},
		},
	},
});

export default injectSheet(styles)(BudgetInput);



// WEBPACK FOOTER //
// ./src/modules/budget/components/budgetInput.jsx